<template>
  <div
    class="sidebar"
    :data="backgroundColor"
  >
    <div
      ref="sidebarScrollArea"
      class="sidebar-wrapper"
    >
      <div class="logo">
        <a
          href="https://liveswitch.io"
          class="simple-text logo-mini"
        >
          <img
            :src="logo"
            alt="app-logo"
          >
        </a>
        <a
          href="https://liveswitch.io"
          class="simple-text logo-normal"
        >
          <img
            :src="logoName"
            :alt="title"
          >
        </a>
      </div>
      <slot />
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, i) in link.children"
              :key="subLink.name + i"
              :link="subLink"
            />
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "side-bar",
  props: {
    title: {
      type: String,
      default: "Ethos",
      description: "Sidebar title",
    },
    shortTitle: {
      type: String,
      default: "E",
      description: "Sidebar short title",
    },
    logo: {
      type: String,
      default: "img/ethos-logo.svg",
      description: "Sidebar app logo",
    },
    logoName: {
      type: String,
      default: "img/ethos-name.svg",
      description: "Sidebar app name",
    },
    backgroundColor: {
      type: String,
      default: "ethos",
      validator: (value) => {
        const acceptedValues = [
          "",
          "vue",
          "blue",
          "green",
          "orange",
          "red",
          "primary",
          "ethos",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar background color (vue|blue|green|orange|red|primary)",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these.",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
.logo-normal {
  height: 50px;
  width: 130px;
}
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
